import { CSSProperties, ReactNode } from 'react';

import { BgColors, DelayTiming, DurationTiming } from '@pukka/common/types';
import { twMerge } from 'tailwind-merge';

interface ProgressProps {
  readonly value?: number; // 0 - 1
  readonly color?: BgColors;
  readonly duration?: DurationTiming;
  readonly delay?: DelayTiming;
  readonly className?: string;
  readonly children?: ReactNode;
  readonly style?: CSSProperties;
}

function Progress({
  value = 0,
  color = 'bg-brand',
  duration = 'duration-500',
  delay = 'delay-0',
  style,
  className,
  children,
}: ProgressProps) {
  return (
    <div className={twMerge('w-full overflow-hidden rounded-sm', 'bg-neutral-300', className)} style={style}>
      <div
        className={twMerge('py-[1px] transition-all ease-in-out', duration, delay, color)}
        style={{
          width: `${value * 100}%`,
        }}
      >
        {children}
      </div>
    </div>
  );
}

export { Progress };
